import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

const About = () => {
  return (
    <Container className="py-5">
      <Row className="text-center mb-5">
        <Col>
          <h1>About PeaceMobiles</h1>
          <p className="lead">Connecting people through technology.</p>
        </Col>
      </Row>

      <Row className="align-items-center mb-5">
        <Col md={6}>
          <Image src="https://via.placeholder.com/500x300" rounded fluid />
        </Col>
        <Col md={6}>
          <h2>Our Story</h2>
          <p>
            Founded in 2020, PeaceMobiles started with a simple mission: to make high-quality mobile technology accessible to everyone. We believe that a connected world is a better world, and we are committed to creating devices that are not only powerful and reliable but also affordable.
          </p>
          <p>
            From our humble beginnings in a small workshop, we have grown into a global brand, but our values have remained the same. We are passionate about innovation, design, and customer satisfaction.
          </p>
        </Col>
      </Row>

      <Row className="text-center mb-5">
        <Col md={6}>
          <h3>Our Mission</h3>
          <p>
            To empower people with the technology to connect, create, and share.
          </p>
        </Col>
        <Col md={6}>
          <h3>Our Vision</h3>
          <p>
            To be the most trusted and respected mobile brand in the world.
          </p>
        </Col>
      </Row>

      <Row className="text-center">
        <Col>
          <h2>Why Choose Us?</h2>
        </Col>
      </Row>
      <Row className="text-center mt-4">
        <Col md={4}>
          <i className="fas fa-award fa-3x mb-3"></i>
          <h4>Quality</h4>
          <p>We use only the best components in our devices.</p>
        </Col>
        <Col md={4}>
          <i className="fas fa-users fa-3x mb-3"></i>
          <h4>Customer-centric</h4>
          <p>We are always here to help you.</p>
        </Col>
        <Col md={4}>
          <i className="fas fa-lightbulb fa-3x mb-3"></i>
          <h4>Innovation</h4>
          <p>We are constantly pushing the boundaries of technology.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
